import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=a51fd28a&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"
import style0 from "./Events.vue?vue&type=style&index=0&id=a51fd28a&prod&scoped=true&lang=css"
import style1 from "./Events.vue?vue&type=style&index=1&id=a51fd28a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51fd28a",
  null
  
)

export default component.exports